/**
 * Minimal class-name joiner.
 *
 * Accepts `unknown` so guard expressions like `icon && "hover:gap-4"` typecheck
 * even when the guard is a ReactNode; anything that isn't a non-empty string is
 * dropped.
 */
export function cx(...parts: unknown[]): string {
  return parts.filter((p): p is string => typeof p === "string" && p.length > 0).join(" ");
}
